import { getBaseUrl } from '../utils/basePath';

export interface CompanyConfig {
  id: string;
  name: string;
  logo: string;
  favicon: string;
  apiUrl: string;
  configPath: string; // Path to environment-specific JSON config
  aspAccreditationNumber?: string;
  aspName?: string;
  serviceProviderId?: string;
  smpAccesspointId?: string;
  supportEmail?: string;
  features?: {
    showTutorial: boolean;
    allowSelfRegistration: boolean;
  };
}

// Domain to company mapping
const DOMAIN_TO_COMPANY: Record<string, string> = {
  'taxilla.com': 'taxilla',
  'nishesolutions.com': 'nishe',
  'kgrnaudit.com': 'kgrn',
  'mnrdxb.com': 'macAndRose',
  'marsgroup.ae': 'marsgroup',
  'aiverix.ae': 'aiverix',
  "fyient.com": "fyient",
  "asadabbastechnologies.com": "asadabbastechnologies",
  "snbconsulting.ae": "snbconsulting",
  "morocloud.com": "morohub",
  "bancify.me": "bancify",
  "jsr.tax": "jsr"  
};

// Friendly names for companies
const COMPANY_NAMES: Record<string, string> = {
  taxilla: 'Taxilla',
  nishe: 'Nishe',
  kgrn: 'KGRN',
  macAndRose: 'MAC & ROSE',
  marsgroup: 'MarsGroup',
  aiverix: 'Aiverix',
  fyient: 'Fyient',
  asadabbastechnologies: 'AsadAbbas Technologies',
  snbconsulting: 'SNB Consulting',
  morocloud: 'MORO HUB INTEGRATED SOLUTIONS',
  bancify: 'Bancify',
  jsr: 'JSR'
};

// Function to get company identifier from API URL in env or current hostname
export function getCompanyId(): string {
  const apiUrl = import.meta.env.VITE_API_URL || '';
  const currentHostname = window.location.hostname;

  try {
    // 1. Check current hostname for a match in our mapping (handles complex subdomains)
    for (const [domain, id] of Object.entries(DOMAIN_TO_COMPANY)) {
      if (currentHostname.endsWith(domain)) {
        return id;
      }
    }

    // 2. Fallback to API URL hostname
    const apiHostname = new URL(apiUrl).hostname;
    for (const [domain, id] of Object.entries(DOMAIN_TO_COMPANY)) {
      if (apiHostname.includes(domain)) return id;
    }

    return apiHostname.split('.')[0] || 'taxilla';
  } catch {
    return 'taxilla';
  }
}


// Get current company config with dynamic asset paths
export function getCurrentCompanyConfig(): CompanyConfig {
  if (typeof window !== 'undefined' && (window as any).__app_config__) {
    console.log("config from window in companies.ts", (window as any).__app_config__);
    return (window as any).__app_config__;
  }

  const companyId = getCompanyId();
  const name = COMPANY_NAMES[companyId] || companyId.charAt(0).toUpperCase() + companyId.slice(1);
  const apiUrl = import.meta.env.VITE_API_URL || 'https://uae-connect-uat.taxilla.com';
  const mode = import.meta.env.MODE || 'development';
  const base = getBaseUrl();

  console.log("base from companies.ts", base);
  console.log("apiUrl from companies.ts", apiUrl);
  console.log("mode from companies.ts", mode);
  console.log("companyId from companies.ts", companyId);
  console.log("name from companies.ts", name);
  return {
    id: companyId,
    name: name,
    // Assets are expected to be in public/tenants/[companyId]/
    logo: `${base}tenants/${companyId}/logo.png`,
    favicon: `${base}tenants/${companyId}/favicon.ico`,
    apiUrl: apiUrl,
    configPath: `${base}tenants/${companyId}/config.${mode}.json`,
  };
}


